"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatWithMe = void 0;
var _litHtml = require("lit-html");
var _solidUi = require("solid-ui");
var _solidLogic = require("solid-logic");
var _asyncReplace = require("lit-html/directives/async-replace.js");
var _texts = require("./texts");
var _buttonsHelper = require("./buttonsHelper");
require("./styles/ChatWithMe.css");
const ChatWithMe = (subject, context) => {
  const logic = context.session.logic;
  const longChatPane = context.session.paneRegistry.byName('long chat');
  async function* chatContainer() {
    const chatContainer = context.dom.createElement('section');
    chatContainer.setAttribute('class', 'chatSection section-centered');
    chatContainer.setAttribute('aria-labelledby', 'chat-section-title');
    chatContainer.setAttribute('role', 'region');
    chatContainer.setAttribute('data-testid', 'chat');

    // Add hidden title for screen readers
    const title = context.dom.createElement('h3');
    title.id = 'chat-section-title';
    title.className = 'sr-only';
    title.textContent = 'Communication';
    chatContainer.appendChild(title);
    let exists;
    try {
      yield (0, _litHtml.html)`
      <div class="buttonSubSection">
        <div class="actionButton loading-text center" role="status" aria-live="polite">
          ${_texts.loadingMessage.toUpperCase()}
        </div>
      </div>
      `;
      exists = await logic.chat.getChat(subject, false);
    } catch (e) {
      exists = false;
    }
    if (exists) {
      const chatArea = context.dom.createElement('div');
      chatArea.setAttribute('role', 'log');
      chatArea.setAttribute('aria-label', 'Chat conversation');
      chatArea.appendChild(longChatPane.render(exists, context, {}));
      chatContainer.appendChild(chatArea);
      yield chatContainer;
    } else {
      const me = _solidLogic.authn.currentUser();
      let label = (0, _buttonsHelper.checkIfAnyUserLoggedIn)(me) ? _texts.chatWithMeButtonText.toUpperCase() : _texts.logInToChatWithMeButtonText.toUpperCase();
      const button = _solidUi.widgets.button(context.dom, undefined, label, setButtonHandler, {
        needsBorder: true
      });
      async function setButtonHandler(event) {
        event.preventDefault();
        try {
          const chat = await logic.chat.getChat(subject, true);
          chatContainer.innerHTML = '';
          chatContainer.appendChild(longChatPane.render(chat, context, {}));
        } catch (error) {
          (0, _buttonsHelper.complain)(chatContainer, context, error);
        }
      }
      button.refresh = refreshButton();
      function refreshButton() {
        const me = _solidLogic.authn.currentUser();
        if ((0, _buttonsHelper.checkIfAnyUserLoggedIn)(me)) {
          button.innerHTML = _texts.chatWithMeButtonText.toUpperCase();
        } else {
          //not logged in
          button.innerHTML = _texts.logInToChatWithMeButtonText.toUpperCase();
        }
      }
      button.setAttribute('type', 'button');
      button.setAttribute('aria-describedby', 'chat-button-description');
      const description = context.dom.createElement('span');
      description.id = 'chat-button-description';
      description.className = 'sr-only';
      description.textContent = 'Start a new conversation or sign in to continue existing chat';
      button.classList.add('actionButton', 'btn-primary', 'action-button-focus');
      chatContainer.appendChild(button);
      chatContainer.appendChild(description);
      yield chatContainer;
    }
  }
  return (0, _litHtml.html)` ${(0, _asyncReplace.asyncReplace)(chatContainer())} `;
};
exports.ChatWithMe = ChatWithMe;